import { HCA_RETURN_URL } from 'api/hcaApi';
import useSfmc from 'hooks/useSfmc';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from 'redux/authentication/slice';
import { getUrlCountryPath } from 'utils/urlUtils';

const HCA_SCRIPT_ID = 'hca-sdk';
const HCA_SDK_SRC = 'https://static.healthcaresdks.com/hca/v1/onekey-hca-sdk.js';


const HcaSdk = ({client_id}) => {
  const [type, setType] = useState('text/javascript');
  const dispatch = useDispatch();

  // Create Token Api
  const tokenCallBack = (tokenInfo) => {
    dispatch(authActions.hca.login({ hcausertoken: tokenInfo?.idToken }))
  }

  const loginCallBack = () => {
    const url = localStorage.getItem('owaPathName');

    // Redirect to return url after successful login
    if(localStorage.getItem(HCA_RETURN_URL) && url) { 
      window.location.href = JSON.parse(window.localStorage.getItem(HCA_RETURN_URL)); 
      localStorage.removeItem(HCA_RETURN_URL);
    }

    localStorage.removeItem("owaPathName");
    localStorage.removeItem("owaPathSearch");

    window.hcaSdk?.getAccessTokenSilent();
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.hcaSdk) {
        // console.log(`HCA SDK loaded with client id ${client_id}`);
        const hcaSdk = window.hcaSdk;

        hcaSdk.setHcaSdkConfig(
          client_id,
          false,
          false,
          ['openid', 'https://auth.onekeyconnect.com/x/profile.extended'],
        );

        hcaSdk.setLoginCallBack(loginCallBack);
        hcaSdk.setTokenCallBack(tokenCallBack);

        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [client_id]);

  // Append hca sdk script to the end of body
  const loadSDK = () => {
    let script = document.getElementById(HCA_SCRIPT_ID);

    if (script) script.remove();

    script = document.createElement('script');
    script.id = HCA_SCRIPT_ID;
    script.src = HCA_SDK_SRC;
    script.type = type;

    document.body.append(script);
  };

  useEffect(() => {
    loadSDK();
  }, []);

  return null;
};

export default HcaSdk;
